// @flow
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { UploadCsvFormDiv, SuccessH4 } from './ImportCsvStyles';
import FileUpload from '../../../../components/FileUpload';
import SubmitButton from '../../../../components/SubmitButton';
import { handleSubmit } from './handleSubmit';
import { requiredField } from '../../../../utilities/validations';
import { Mobile } from '../../../../components/Responsive';

type Props = {
  handleSubmit: () => void,
  submitting: boolean,
  error: ?string,
  submitSucceeded: boolean
};

class UploadCsvForm extends Component<Props> {
  render() {
    return (
      <UploadCsvFormDiv onSubmit={this.props.handleSubmit}>
        <Mobile>
          <h4>Upload Csv File Here</h4>
        </Mobile>
        <Field
          name="file"
          isDragActive
          component={FileUpload}
          acceptedFileTypes=".csv"
          maxSize={5000000}
          setFileUploadDirty={() => true}
          fileUploadDirty={() => true}
          validate={requiredField}
        />
        <SubmitButton
          value="Start Import"
          disabled={this.props.submitting}
          error={this.props.error}
          marginTop="2rem"
        />
        {this.props.submitSucceeded && (
          <>
            <SuccessH4>You have successfully uploaded the CSV file. </SuccessH4>
            <p>
              We’ll send you an email notification once it’s been processed.
            </p>
          </>
        )}
      </UploadCsvFormDiv>
    );
  }
}

export default reduxForm({
  form: 'uploadCsvForm',
  onSubmit: handleSubmit
})(UploadCsvForm);
